import { axios } from "axios"
import { useState } from 'react';
import { useEffect } from 'react';
import "./Trending.css"
import { SingleContent } from './../SingleContent/SingleContent';
import { Pagination, PaginationPage } from './../Pagination/Pagination';

export const Trending = () => {
    const [trendingContent, setTrendingContent] = useState([]);
    const [page, setPage] = useState(1)
    const fetchTrendingData = () => {

        fetch(`https://api.themoviedb.org/3/trending/all/week?api_key=55d3986357276fb32520164149dcabe4&page=${page}`)
            .then(res => res.json())
            .then(json => setTrendingContent(json.results))

    }


    useEffect(() => {
        window.scroll(0, 0)
        fetchTrendingData();
    }, [page])
    return (
        <>
            <div>
                <span className="pagetitle">Trending</span>
                <div className="trending">
                    {trendingContent && trendingContent.map((ele) =>
                        // console.log(ele)
                        <SingleContent key={ele.id} output={ele} />
                    )}
                </div>
                <PaginationPage setPage={setPage} />
                {console.log(page)}
            </div>

        </>
    )
}